module.exports = __webpack_public_path__ + "static/media/pic-3.75bf8a3d.jpg";